export default __webpack_public_path__ + "static/HeronSansCondBold-5992cf28c7b25be7b147a3f709e535dc.woff";